import { Nullable } from '@kts-front/types';
import { z } from 'zod';

import { PlaceTypeEntityApi, placeTypeSchema } from 'entities/PlaceType';

export const projectSchema = z
  .object({
    id: z.number(),
    name: z.string(),
    // color: z.string(),
    place_types: z.array(placeTypeSchema),
  })
  .transform((raw) => {
    return {
      id: raw.id,
      name: raw.name,
      // color: raw.color,
      placeTypes: raw.place_types,
    };
  });

export type ProjectEntityApi = z.input<typeof projectSchema>;

export type ProjectEntity = z.infer<typeof projectSchema>;

export interface ProjectListItemServer {
  id: number;
  name: string;
  place_types: PlaceTypeEntityApi[];
  minimal_lot_price: Nullable<number>;
}

export interface ProjectListServer {
  items: ProjectListItemServer[];
  total: number;
}
